// selectedFieldSlice.ts
import { KeyValuePair, KeyValueState } from '@/interface/key-value.interface';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: KeyValueState = {
  data: {},
  status: 'idle',
  error: null
};

export const selectedFieldSlice = createSlice({
  name: 'selectedField',
  initialState,
  reducers: {
    setSelectedField: (state, action: PayloadAction<KeyValuePair>) => {
      state.data = action.payload;
      state.status = 'succeeded';
      state.error = null;
    },
    clearSelectedField: (state) => {
      state.data = {};
      state.status = 'idle';
      state.error = null;
    },
    setSelectedFieldLoading: (state) => {
      state.status = 'loading';
    },
    setSelectedFieldError: (state, action: PayloadAction<string>) => {
      state.status = 'failed';
      state.error = action.payload;
    }
  },
});

export const { 
  setSelectedField, 
  clearSelectedField,
  setSelectedFieldLoading,
  setSelectedFieldError
} = selectedFieldSlice.actions;

// Selectors
export const selectSelectedField = (state: { selectedField: KeyValueState }) => state.selectedField.data;
export const selectSelectedFieldStatus = (state: { selectedField: KeyValueState }) => state.selectedField.status;
export const selectSelectedFieldError = (state: { selectedField: KeyValueState }) => state.selectedField.error;

export default selectedFieldSlice.reducer;